import { defineComponent, ref } from 'vue';
import Banner from '@/components/Banner.vue';
import NavHeader from '@/components/NavHeader.vue';
import FaqNOC from './components/FaqNOC.vue';
import FaqQECIT from './components/FaqQECIT.vue';
import BannerImage from '@/assets/image/banner/banner4@2x.png';
export default defineComponent({
  name: 'ItemFaq',
  components: {
    Banner: Banner,
    NavHeader: NavHeader,
    FaqNOC: FaqNOC,
    FaqQECIT: FaqQECIT
  },
  setup: function setup() {
    var current = ref(1);
    var activityTypeList = ref([{
      code: 1,
      name: 'NOC大赛'
    }, {
      code: 2,
      name: '等级考试'
    }]);

    var onActivityTypeChange = function onActivityTypeChange(item) {
      current.value = item.code;
    };

    return {
      BannerImage: BannerImage,
      current: current,
      activityTypeList: activityTypeList,
      onActivityTypeChange: onActivityTypeChange
    };
  }
});